import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriQuickStockNotificationComponent } from '../../components/gonvarri-quick-stock-notification/gonvarri-quick-stock-notification.component';
import {I18nModule, provideConfig} from "@spartacus/core";
import {
  gonvarriQuickStockNotificationLayoutConfig
} from "../../layouts/gonvarri-quick-stock-notification-layout-config";
import {IconModule} from "@spartacus/storefront";
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    GonvarriQuickStockNotificationComponent
  ],
  imports: [
    CommonModule,
    IconModule,
    I18nModule,
    FormsModule
  ],
  providers: [
    provideConfig(gonvarriQuickStockNotificationLayoutConfig)
  ]
})
export class GonvarriQuickStockNotificationModule { }
